import { OntologyFieldDataType } from '@packages/enums';

export interface OntologyField {
    id: string;
    name: string;
    displayName: string;
    description: string;
    dataType: OntologyFieldDataType;
    extractionInstruction: string;
    exampleValues?: string[];
    required?: boolean;
    createdAt?: string;
    category: string;
}

export type OntologyFields = OntologyField[];

export interface Ontology {
    id: string;
    name: string;
    display_name?: string | null;
    description: string | null;
    owner_id: string | null; // Null for preset ontologies
    is_preset: boolean;
    output_schema?: string | null;
    fields: OntologyFields;
    created_at: string;
    updated_at: string;
}

export interface OntologySummary {
    id: string;
    name: string;
    display_name?: string | null;
    description: string | null;
    owner_id: string | null;
    is_preset: boolean;
    output_schema?: string | null;
    field_count: number;
    created_at: string;
    updated_at: string;
}

export interface CreateOntologyRequest {
    name: string;
    display_name?: string | null;
    description?: string;
    output_schema?: string | null;
    fields: OntologyFields;
}

export interface UpdateOntologyRequest {
    name?: string;
    display_name?: string | null;
    description?: string;
    output_schema?: string | null;
    fields?: OntologyFields;
}

export interface OntologyListResponse {
    ontologies: OntologySummary[];
    total: number;
}
